import { useMemo } from 'react';
import { object, string } from 'yup';

const schemaRequired = string().nullable().required('is required');

export function useSchemaForCreate() {
  return object({
    email: schemaRequired.email('must be a valid email'),
  });
}

export function useSchemaForUpdate(current, isOpen) {
  return useMemo(
    () =>
      object({
        password: schemaRequired
          .test(
            'not-match-current-password',
            'must not match Current Password',
            (value, context) => value !== context.parent.current_password
          )
          .test(
            'password-complexity',
            'password-complexity', // human readable message will be handled by PasswordStrengthMeter
            (value) => {
              const SPECIALCHARREGEX =
                // eslint-disable-next-line no-useless-escape
                /[~`¿¡!#$%\^&*€£@+÷=\-\[\]\\';,/{}\(\)|\\":<>\?\.\_]/;
              let isValid =
                value?.length >= 12 &&
                /\d/g?.test(value) &&
                /[A-Z]/g?.test(value) &&
                SPECIALCHARREGEX?.test(value);

              return isValid;
            }
          ),
        password_confirmation: string().test(
          'match-password',
          'Passwords must match',
          (value, context) => value === context.parent.password
        ),
      }),
    []
  );
}
